"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMachines = useMachines;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _contexts = require("../sfra-api/contexts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * A hook for managing machines state and actions
 * @returns {Object} Machines data and actions
 */
function useMachines() {
  const mounted = (0, _react.useRef)();
  const SFRAClient = (0, _contexts.useCommerceSFRAAPI)();
  const [state, setState] = (0, _react.useState)({
    machines: [],
    registerableMachines: [],
    isLoading: true,
    isLoadingRegistrable: true,
    isProcessingAction: false
  });

  // @ts-ignore
  const mergeState = (0, _react.useCallback)(data => {
    // If we become unmounted during an async call that results in updating state, we
    // skip the update to avoid React errors about setting state in unmounted components.
    if (!mounted.current) {
      return;
    }
    setState(_state => _objectSpread(_objectSpread({}, _state), data));
  });

  // We use this to track mounted state.
  (0, _react.useEffect)(() => {
    // @ts-ignore
    mounted.current = true;
    return () => {
      // @ts-ignore
      mounted.current = false;
    };
  }, []);
  const ctx = (0, _react.useMemo)(() => {
    return _objectSpread(_objectSpread({}, state), {}, {
      // Getter functions
      // Provides convenient access to various data points and derivations.
      // ----------------

      /**
       * Returns boolean value whether the customer has registered machines
       */
      get hasMachines() {
        return ctx.machines.length > 0;
      },
      /**
       * Returns boolean value whether the customer has registerable machines
       */
      get hasRegisterableMachines() {
        return ctx.registerableMachines.length > 0;
      },
      /**
       * Get registered machines for the current customer
       * @returns {Promise}
       */
      getMachines() {
        return (0, _asyncToGenerator2.default)(function* () {
          mergeState({
            isLoading: true
          });
          // @ts-ignore
          return SFRAClient === null || SFRAClient === void 0 ? void 0 : SFRAClient.Machines.getMachines({
            query: ''
          }).then(res => mergeState({
            machines: res.machines
          })).catch(error => error).finally(() => mergeState({
            isLoading: false
          }));
        })();
      },
      /**
       * Get unregistered machines purchased by the current customer
       * @returns {Promise}
       */
      getRegisterableMachines() {
        return (0, _asyncToGenerator2.default)(function* () {
          mergeState({
            isLoadingRegistrable: true
          });
          // @ts-ignore
          return SFRAClient === null || SFRAClient === void 0 ? void 0 : SFRAClient.Machines.getRegisterableMachines({
            query: {
              UnregisteredOnly: true
            }
          }).then(res => mergeState({
            registerableMachines: res.registerableMachines
          })).catch(error => error).finally(() => mergeState({
            isLoadingRegistrable: false
          }));
        })();
      },
      /**
       * Register a new machine to the current customer
       * @param {object} args Object containing the request arguments (query, body, headers, etc...)
       * @returns {Promise}
       */
      addMachine(args) {
        return (0, _asyncToGenerator2.default)(function* () {
          mergeState({
            isProcessingAction: true
          });
          // @ts-ignore
          return SFRAClient === null || SFRAClient === void 0 ? void 0 : SFRAClient.Machines.addMachine(args).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(function* () {
            yield ctx.getRegisterableMachines();
            return yield ctx.getMachines();
          })).finally(() => mergeState({
            isProcessingAction: false
          }));
        })();
      },
      /**
       * Update an existing machine on the current customer's profile
       * @param {object} args Object containing the request arguments (query, body, headers, etc...)
       * @returns {Promise}
       */
      updateMachine(args) {
        return (0, _asyncToGenerator2.default)(function* () {
          mergeState({
            isProcessingAction: true
          });
          // @ts-ignore
          return SFRAClient === null || SFRAClient === void 0 ? void 0 : SFRAClient.Machines.updateMachine(args).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(function* () {
            return yield ctx.getMachines();
          })).finally(() => mergeState({
            isProcessingAction: false
          }));
        })();
      },
      /**
       * Remove a registered machine from the current customer
       * @param {object} args Object containing the request arguments (query, body, headers, etc...)
       * @returns {Promise}
       */
      removeMachine(args) {
        return (0, _asyncToGenerator2.default)(function* () {
          mergeState({
            isProcessingAction: true
          });
          // @ts-ignore
          SFRAClient === null || SFRAClient === void 0 ? void 0 : SFRAClient.Machines.removeMachine(args).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(function* () {
            yield ctx.getRegisterableMachines();
            return yield ctx.getMachines();
          })).catch(error => error).finally(() => mergeState({
            isProcessingAction: false
          }));
        })();
      }
    });
  }, [state, mergeState]);
  return ctx;
}